import React from 'react';  // eslint-disable-line

const Calendar = () => {
    return (
        <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg">
            <path transform="translate(-15 -15)" fill="#304FFE" fillRule="nonzero" d="M16 19h13v-2h-2v1h-1v-1h-3v1h-1v-1h-3v1h-1v-1h-2v2zm0 1v9h13v-9H16zm10-4v-1h1v1h3v14H15V16h3v-1h1v1h3v-1h1v1h3z" id="a" />
        </svg>
    );
};

export default Calendar;
